<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : outStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1000px"
      class="outStockBillsEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="outStockBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="出库单号" prop="billNo">
            <el-input v-model="outStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出库类型" prop="outStockType">
            <el-select v-model="outStockBills.outStockType" placeholder="请选择出库类型">
              <el-option label="销售出库" :value="0"/>
              <el-option label="仓库发料" :value="1"/>
              <el-option label="生产领料" :value="2" disabled/>
              <el-option label="调拨出库" :value="3"/>
              <el-option label="委外出库" :value="4"/>
              <el-option label="退货出库" :value="5"/>
              <el-option label="盘亏出库" :value="6"/>
              <el-option label="自用出库" :value="7"/>
              <el-option label="工单发料" :value="8"/>
              <el-option label="反冲出库" :value="9"/>
              <el-option label="报废出库" :value="10"/>
              <el-option label="其他出库" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单据编号" prop="relBillNo">
            <el-input v-model="outStockBills.relBillNo" placeholder="请输入关联单据编号"/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.status === 2" :span="12">
          <el-form-item label="出库时间" prop="requireDate">
            <el-input v-model="outStockBills.requireDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="outStockBills.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="outStockBills.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="outStockBills.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="备注" prop="note">
            <el-input v-model="outStockBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">出库明细</div>
      <el-button v-if="!disabled" type="primary" style="margin-bottom: 10px" @click="$refs.selectInventory.open()"> 添加 </el-button>
      <el-table class="tableBox" :data="outStockBills.outStockBillDetailVOS" border>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column 
            prop="materialName" 
            align="left" 
            label="物料名称" 
            min-width="380" 
            show-overflow-tooltip/>
        <el-table-column 
            prop="locationName" 
            align="left" 
            label="库位" 
            width="120" 
            show-overflow-tooltip/>
        <el-table-column prop="originQuantity" align="center" label="库存" width="80"/>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <el-table-column prop="price" align="center" label="单价" width="60"/>
        <el-table-column align="center" label="出库数量" width="100" prop="quantity">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" placeholder="请输入" @change="changeQuantity(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column 
            v-if="!disabled" 
            prop="note" 
            align="center" 
            label="备注" 
            width="120" 
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <inventory-select ref="selectInventory" @select="selectInventory" @selectMore="selectMoreInventory"/>
  </el-dialog>
</template>

<script>
  import InventorySelect from "../Inventory/InventorySelect.vue";
  export default {
    name: "OutStockOrderEdit",
    components: { InventorySelect },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        outStockBills: {
          outStockType: "",
          pkid: 0,
          billNo: "",
          relBillNo: "",
          requireDate: "",
          status: "",
          creatorName: "",
          createTime: "",
          note: "",
          outStockBillDetailVOS: [],
        },
        ruleValidate: {
          outStockType: { required: true, message: "请选择出库类型", trigger: "change" },
          quantity: { required: true, trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, disabled) {
        this.dialogVisible = true;
        if (row) {
          this.outStockBills.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      selectInventory(row) {
        const arr = this.outStockBills.outStockBillDetailVOS.filter(
          (item) => item.materialNo === row.materialNo && item.locationId === row.locationId
        );
        if (arr.length) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const materialItem = {
          materialSn: row.materialSn,
          unitId: row.unitId,
          unitName: row.unitName,
          materialId: row.materialId,
          materialNo: row.materialNo,
          materialName: row.materialName,
          quantity: row.quantity,
          price: row.price,
          locationId: row.locationId,
          locationName: row.locationName,
          note: "",
          originQuantity: row.quantity,
        };
        this.outStockBills.outStockBillDetailVOS.push(materialItem);
      },

      selectMoreInventory(row) {
        row.forEach(item=>{
          this.selectInventory(item);
        });
      },

      // 数量编辑校验
      changeQuantity(row) {
        const reg = /^[0-9]*.\d{0,2}$/;
        if (!reg.test(row.quantity) || row.quantity <= 0) {
          this.$confirm("请输入正确的送货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },

      // 删除物料
      deleteMaterial(index) {
        this.outStockBills.outStockBillDetailVOS.splice(index, 1);
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `outStockBills/${this.outStockBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.outStockBills = Object.assign(this.outStockBills, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.outStockBills.outStockBillDetailVOS.length) {
              this.$confirm("请添加出库明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "outStockBills", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.outStockBills.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.outStockBillsEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.outStockBillsEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.outStockBillsEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.outStockBillsEdit .el-divider--horizontal {
  margin: 10px 0;
}

.outStockBillsEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
